module.exports = "https://coursera_assets.s3.amazonaws.com/images/e913f43a6bff69a95a947cc11b42a030.png";